(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'siteFooter', {
            templateUrl:  'app/views/partials/layout/site-footer.html',
            controller:   FooterController,
            controllerAs: 'vm'
        });

    /**
     * Renders header common for all the views on the website.
     *
     * @type {ng.IController}
     *
     * @param {ng.IScope} $scope
     * @param {App} App
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function FooterController(
        $scope,
        App,
        TEXTS,
        CONFIG
    ){

        // Helper members.
        /** @type {ng.IController} */
        var vm = this;


        /** Expose to the Scope */

        $scope._        = TEXTS.GENERIC;
        $scope.CONFIG   = CONFIG;


        /** Expose to the Controller */
        vm.isPublicMode = App.isPublicMode();
    }


    FooterController.$inject = [ '$scope', 'App', 'TEXTS', 'CONFIG' ];
})();
